export const insuranceDurationUnitEnum = [
  {
    stateId: "DAY",
    stateName: "天"
  },
  {
    stateId: "MONTH",
    stateName: "月"
  },
  {
    stateId: "YEAR",
    stateName: "年"
  },
]